(function () {
    'use strict';
    angular
        .module('portalApp')
        .factory('PublicCurves', PublicCurves);

    PublicCurves.$inject = ['$resource'];

    function PublicCurves($resource) {
        var resourceUrl = 'api/open/ycm/public-curves';

        return $resource(resourceUrl, {}, {
            'get': {method: 'GET'}
        });
    }
})();
